import {useUpmPlantContext} from '@hconnect/upm'

import {
  isStorageWithMaterialGuard,
  calculateCapacityForStorages,
  calculateDeadStockLevelForStorages,
  calculateMinTargetLevelForStorages
} from '../selectors'
import {MaterialStorage} from '../types'

import {useCurrentMaterialStorages} from './useCurrentMaterialStorages'

const selector = (storages: MaterialStorage[], materialId: number) => {
  const storagesWithMaterial = storages
    .filter(isStorageWithMaterialGuard)
    .filter((storage) => storage.materialId === materialId)

  const minTargetLevels = calculateMinTargetLevelForStorages(storagesWithMaterial)
  const deadStockLevel = calculateDeadStockLevelForStorages(storagesWithMaterial)
  const storageCapacity = calculateCapacityForStorages(storagesWithMaterial)
  return {...minTargetLevels, deadStockLevel, storageCapacity}
}

interface MaterialStorageDataQueryParams {
  materialId: number
}

export const useMaterialStorageDataQuery = ({materialId}: MaterialStorageDataQueryParams) => {
  const {plantId: plantCode} = useUpmPlantContext()
  return useCurrentMaterialStorages<ReturnType<typeof selector>>({
    plantId: plantCode,
    options: {select: (data: MaterialStorage[]) => selector(data, materialId), throwOnError: true}
  })
}
